// extracted by mini-css-extract-plugin
export default {"modal":"hfa-z","modalContent":"ifa-z","footer":"jfa-z","cancelBtn":"kfa-z","disabled":"lfa-z","formWrapper":"mfa-z","fade":"nfa-z","fade-in":"ofa-z","iframe":"pfa-z"};